import { render, staticRenderFns } from "./khfw.vue?vue&type=template&id=845a5686&scoped=true"
import script from "./khfw.vue?vue&type=script&lang=js"
export * from "./khfw.vue?vue&type=script&lang=js"
import style0 from "./khfw.vue?vue&type=style&index=0&id=845a5686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845a5686",
  null
  
)

export default component.exports